import { routerWillChange, routerHasChange, routerForward, routerBackward } from '@constrant/Enum';

window.routerStack = new service.Stack();

function install(router) {
  router.beforeEach((to, from, next) => {

    // 路由栈
    const stackTop = window.routerStack.first();
    if (to.path == stackTop) {
      window.routerStack.pop();

      // 广播后退
      service.Hookable.callHook(routerBackward);
    } else {
      !!from.path && from.path != '/' && window.routerStack.push(from.path);
      
      // 广播前进
      service.Hookable.callHook(routerForward);
    }

    // 广播router.beforeEach事件
    service.Hookable.callHook(routerWillChange, to, from);

    next();
  });

  router.afterEach((to, from) => {
    // 广播router.afterEach事件
    service.Hookable.callHook(routerHasChange, to, from);
  });
}

export default install;
